"use client";

import { BoutiqueCard } from "@/components/client/shops/components/BoutiqueCard";
import { ComingSoonCard } from "@/components/client/shops/components/ComingSoonCard";
import { HeritageBanner } from "@/components/shared/HeritageBanner";
import { useSettings } from "@/features/settings/hook/useSettings";

const BOUTIQUES_DATA = [
    {
        city: "Mostaganem",
        address: "27000, Boulevard de la Salamandre, Mostaganem.",
        phone: "+213 (0) 45 XX XX XX",
        image: "/images/site/shop_mostaganem.png",
    },
    {
        city: "Oran",
        address: "31000, Avenue Canastel, La Corniche d'Or, Oran.",
        phone: "+213 (0) 41 XX XX XX",
        image: "/images/site/shop_oran.png",
    },
    {
        city: "Alger",
        address: "16000, Rue Didouche Mourad, Alger Centre.",
        phone: "+213 (0) 21 XX XX XX",
        image: "/images/site/shop_alger.png",
    }
];

export default function ShopsPage() {
    const { data: settings } = useSettings();

    // Deriving social links from global settings (as requested)
    const socialLinks = {
        facebook: settings?.social?.facebook ? `https://facebook.com/${settings.social.facebook}` : undefined,
        instagram: settings?.social?.instagram ? `https://instagram.com/${settings.social.instagram.replace("@", "")}` : undefined,
        tiktok: settings?.social?.tiktok ? `https://tiktok.com/@${settings.social.tiktok.replace("@", "")}` : undefined,
    };

    return (
        <main className="min-h-screen bg-[#FBF9F4]">
            {/* Header Section */}
            <section className="container mx-auto px-4 pt-16 pb-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
                    <div className="max-w-2xl">
                        <h1 className="font-brastika text-5xl md:text-7xl text-primary-900 mb-6">
                            Nos Boutiques
                        </h1>
                        <p className="text-primary-700 text-lg md:text-xl leading-relaxed opacity-80">
                            Découvrez l&apos;art de l&apos;apothicaire moderne à travers l&apos;Algérie.
                            Des espaces de sérénité où les senteurs du patrimoine rencontrent le luxe contemporain.
                        </p>
                    </div>

                    <div className="shrink-0">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-primary-100 shadow-sm text-xs font-semibold text-primary-600 tracking-widest uppercase">
                            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                            3 Destinations Ouvertes
                        </div>
                    </div>
                </div>

                {/* Boutiques Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
                    {settings?.locations && settings.locations.length > 0 ? (
                        settings.locations.map((loc, index) => (
                            <BoutiqueCard
                                key={loc.id}
                                city={loc.city || loc.name}
                                address={`${loc.address}${loc.city ? `, ${loc.city}` : ""}${loc.state ? ` (${loc.state})` : ""}`}
                                phone={loc.phone || "+213 XX XX XX XX XX"}
                                latitude={loc.latitude}
                                longitude={loc.longitude}
                                image={index === 0 ? "/images/site/shop_mostaganem.png" : "/images/site/shop_mostaganem.png"}
                                facebookUrl={socialLinks.facebook}
                                instagramUrl={socialLinks.instagram}
                                tiktokUrl={socialLinks.tiktok}
                            />
                        ))
                    ) : (
                        BOUTIQUES_DATA.map((boutique, index) => (
                            <BoutiqueCard
                                key={boutique.city}
                                {...boutique}
                                // If it's the first one, use our generated image, others fallback to placeholders or same for now
                                image={index === 0 ? "/images/site/shop_mostaganem.png" : "/images/site/shop_mostaganem.png"}
                                facebookUrl={socialLinks.facebook}
                                instagramUrl={socialLinks.instagram}
                                tiktokUrl={socialLinks.tiktok}
                            />
                        ))
                    )}
                    <ComingSoonCard />
                </div>

                {/* Banner Section */}
                <HeritageBanner
                    title="Un Héritage Local"
                    subtitle="Retrouvez l'essence de notre terroir dans chaque point de vente. Chaque boutique est conçue comme un hommage à l'artisanat Algérien."
                    image="/images/site/heritage_banner.png"
                    className="mt-12"
                />
            </section>
        </main>
    );
}
